import { subscribe } from '@/utils'

import { Params, Response, Service } from '.'

const login = async (params: Params): Promise<Response> => {
	try {
		const body = {
			...params
		}
		const res = await subscribe.post<Response>('account/login', body)
		return res.data
	} catch (e) {
		throw e
	}
}

export const service: Service = {
	login
}
